/**
 * The "a" lettermark (espresso "a" with burnt-orange and mustard arcs), traced from LOGO_V3_ICON.
 * Mirrors components/LogoMark.tsx so the browser tab and downloads match the header.
 */
const MARK_PATHS = `<path d="M885 575 A555 555 0 0 1 1440 1130 V1490" stroke="#e2a33a"/>
<path d="M885 695 A435 435 0 0 1 1320 1130 V1490" stroke="#b8431a"/>
<circle cx="885" cy="1130" r="320" stroke="#1d1814"/>
<path d="M1205 1130 V1490" stroke="#1d1814"/>`;

/** Transparent background, for general use. */
export const LOGO_MARK_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="507 517 990 990" width="990" height="990" fill="none" stroke-width="70">
${MARK_PATHS}
</svg>`;

/** On a cream rounded square, so the espresso "a" stays visible on dark browser tabs. */
export const FAVICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="412 422 1180 1180" width="1180" height="1180" fill="none" stroke-width="70">
<rect x="412" y="422" width="1180" height="1180" rx="270" fill="#f8f4ec"/>
${MARK_PATHS}
</svg>`;

/** Replaces any existing tab icon with the logo mark. */
export function applyFavicon() {
  if (typeof document === "undefined") return;
  const href = `data:image/svg+xml,${encodeURIComponent(FAVICON_SVG)}`;

  document
    .querySelectorAll<HTMLLinkElement>('link[rel~="icon"], link[rel="apple-touch-icon"]')
    .forEach((el) => el.remove());

  for (const rel of ["icon", "apple-touch-icon"]) {
    const link = document.createElement("link");
    link.rel = rel;
    link.type = "image/svg+xml";
    link.href = href;
    document.head.appendChild(link);
  }
}
